module.exports = __webpack_public_path__ + "assets/google_play.png?3ccb8b89c9361f6e921d743f9d51a25b";